export class Navigation {
    constructor() {
        this.header = document.querySelector('.site-header');
        if (!this.header) return;

        this.navLinks = Array.from(this.header.querySelectorAll('.nav-link'));
        this.navList = this.header.querySelector('.nav-list');
        this.navContainer = this.header.querySelector('.nav-container');

        this.lastScrollY = window.scrollY;

        this.init();
    }

    init() {
        this.initMobileMenu();
        this.initEvents();
        this.setupScrollTrigger();
    }

    initMobileMenu() {
        if (!this.navContainer || !this.navList) return;
        this.mobileBtn = document.createElement('button');
        this.mobileBtn.className = 'mobile-menu-btn';
        this.mobileBtn.textContent = 'MENU';
        this.mobileBtn.setAttribute('aria-expanded', 'false');
        this.mobileBtn.setAttribute('aria-label', 'Open mobile menu');
        this.navContainer.appendChild(this.mobileBtn);

        this.mobileBtn.addEventListener('click', () => {
            if (this.navList.classList.contains('is-open')) {
                this.navList.classList.remove('is-open');
                this.mobileBtn.textContent = 'MENU';
                this.mobileBtn.setAttribute('aria-expanded', 'false');
                this.mobileBtn.setAttribute('aria-label', 'Open mobile menu');
                document.body.style.overflow = '';
            } else {
                this.navList.classList.add('is-open');
                this.mobileBtn.textContent = 'CLOSE';
                this.mobileBtn.setAttribute('aria-expanded', 'true');
                this.mobileBtn.setAttribute('aria-label', 'Close mobile menu');
                document.body.style.overflow = 'hidden';
            }
        });

        this.navLinks.forEach((link) => {
            link.addEventListener('click', () => {
                this.navList.classList.remove('is-open');
                this.mobileBtn.textContent = 'MENU';
                document.body.style.overflow = '';
            });
        });
    }

    initEvents() {
        // Magnetic Hover Effect
        this.navLinks.forEach((link) => {
            link.addEventListener('mousemove', (e) => this.hoverEffect(e, link));
            link.addEventListener('mouseleave', () => this.resetHover(link));
        });
    }

    hoverEffect(e, element) {
        // Calculate mouse position relative to element center for magnetic effect
        const rect = element.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        const distanceX = (e.clientX - centerX) * 0.4; // Magnetic strength multiplier
        const distanceY = (e.clientY - centerY) * 0.4;

        gsap.to(element, {
            x: distanceX,
            y: distanceY,
            duration: 0.3,
            ease: 'power3.out',
            overwrite: 'auto',
        });
    }

    resetHover(element) {
        gsap.to(element, {
            x: 0,
            y: 0,
            duration: 0.6,
            ease: 'elastic.out(1, 0.4)', // Add slight bounce back for "organic" feel
            overwrite: true,
        });
    }

    setupScrollTrigger() {
        // Simple scroll direction tracking without complex ScrollTrigger configuration
        // This is often more reliable for simple show/hide headers than ScrollTrigger scrubbers

        let lastScrollY = window.scrollY;

        window.addEventListener('scroll', () => {
            const currentScrollY = window.scrollY;

            // Only toggle if moved significantly or at top
            if (Math.abs(currentScrollY - lastScrollY) < 5) return;

            const direction = currentScrollY > lastScrollY ? 1 : -1;

            if (direction === 1 && currentScrollY > 50) {
                // Scrolling Down -> Hide
                gsap.to(this.header, {
                    yPercent: -100,
                    duration: 0.6,
                    ease: 'power3.out',
                    overwrite: true,
                });
            } else if (direction === -1) {
                // Scrolling Up -> Show
                gsap.to(this.header, {
                    yPercent: 0,
                    duration: 0.6,
                    ease: 'power3.out',
                    overwrite: true,
                });
            }
            lastScrollY = currentScrollY;
        });
    }
}

// Auto-init
new Navigation();
